/* eslint-disable */
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import TuneIcon from '@material-ui/icons/Tune';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import Page from '../../Components/Page/Page.component';
import withServices from '../../Contexts/Services/WithServices.context';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import LayoutsPagePropTypes from './Layouts.page.props';
import layoutsPageStyles from './Layouts.page.styles';
import PageGenericSidebar from './PageGenericSidebar.page.sidebar';
/**
 * LayoutTemplate1PageComponent
 * @export
 * @class LayoutTemplate1PageComponent
 * @extends {React.Component<LayoutTemplate1PageComponentComposedProps, LayoutTemplate1PageComponentState>}
 */
class PageTwoColumnComponent extends Component {
  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConcreteDeliveriesPageComponent
   */
  static propTypes = LayoutsPagePropTypes;

  /**
   * Renders the refine component
   * @returns {React.Component} The rendered filters sidebar
   * @memberof PageTwoColumnComponent
   */
  renderRefine = () => {
    const { width } = this.props;
    const isSmall = isWidthDown(`md`, width);
    return (
      isSmall && (
        <IconButton color="inherit" onClick={this.handleRefineToggle}>
          <TuneIcon />
        </IconButton>
      )
    );
  };

  /**
   * Open the refine menu
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof PageTwoColumnComponent
   */
  handleRefineToggle = (event) => {
    const { actions } = this.props;
    actions.sidebarRightToggle();
    return;
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<LayoutTemplate2Page />`
   * @memberof PageTwoColumnComponent
   */
  render() {
    const { children, classes, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    return (
      <Page
        className={classes.root}
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        overflow="auto"
        renderExtensions={this.renderRefine()}
        sidebarContent={<PageGenericSidebar />}
        {...this.props}
      >
        {children}
      </Page>
    );
  }
}

const PageTwoColumn = compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...sidebarActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(layoutsPageStyles), { withTheme: true }),
)(PageTwoColumnComponent);

export default PageTwoColumn;
